import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { IDynamicElement } from '../../_shared/models/dynamic/dynamic-element.model';
import { ITabGroup } from '../../_shared/models/tab/tab-group.model';
import { SectionComponent } from '../../section/section.component';
import { TabComponent } from '../tab.component';
import { TabGroupV2Component } from './tab-group-v2.component';

@Component({
    selector: 'sirius-tab-group-dynamic-v2',
    template: `
        @if (config(); as config) {
            <sirius-tab-group-v2 [size]="config.size ?? 'large'">
                @for (tab of config.tabs; track $index) {
                    <sirius-tab [title]="tab.title">
                        @for (section of tab.body; track $index) {
                            <sirius-section [config]="section"></sirius-section>
                        }
                    </sirius-tab>
                }
            </sirius-tab-group-v2>
        }
    `,
    styles: ':host { display: block; width: 100%; }',
    imports: [TabGroupV2Component, TabComponent, SectionComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabGroupDynamicV2Component implements IDynamicElement<ITabGroup> {
    readonly config = input<ITabGroup | undefined>(undefined);
}
